import React from 'react';
import {Router, Route, Switch, Redirect} from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore, store } from "./redux/store";
import { history } from './jwt/_helpers';
import { PrivateRoute } from './routes/PrivateRoutes';
import Blanklayout from "./layouts/blanklayout";
import Modulelayout from "./layouts/modulelayout";
import indexRoutes from "./routes";
import {ToastContainer} from "react-toastify";
import Chart from 'chart.js/auto'; //this is important to show the graphics (BI)
import ChartDataLabels from 'chartjs-plugin-datalabels';
import GxMaps from "./views/generic/gxMaps";
import XwitchLogIncognitoForm from "./views/monitor/xwitchLog/XwitchLogIncognitoForm";

// Register the plugin to all charts:
Chart.register(ChartDataLabels);

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: null
        };
    }

    render() {
        return (
            <Provider store={store}>
                <Router basename="/" history={history}>
                    <Switch>
                        <Route path="/authentication/login" component={Blanklayout}/>
                        <Route path="/park/:code/:langCode" component={GxMaps} />
                        <Route path="/xwitchLog/:id" component={XwitchLogIncognitoForm} />
                        <Route
                            exact
                            path="/"
                            render={() => {
                                return (
                                    <Redirect to="/modules/main" />
                                )
                            }}
                        />
                        <PrivateRoute path="/modules/main" component={Modulelayout} />
                        {
                            indexRoutes.map((prop, key) => {
                                return <PrivateRoute path={prop.path} key={key} component={prop.component} />;
                            })
                        }
                    </Switch>
                </Router>
                <ToastContainer/>
            </Provider>
        )
    }
}

export default App;